import * as React       from "react";

import "./watermark-download.scss";

import {cst, cstAssign} from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {Types}          from "@Common/types";

import {downloadProofs} from "../../common/download-proofs";
import {Button}         from "../button/button";

export const WatermarkDownload = ({
/*  PROPS  ************************************************************************************************************/
    itemId,
    ccValues,
    disableSaves,
    loadWatermarkPdf,
}:{
/*  PROP TYPES  *******************************************************************************************************/
    itemId               : string,
    ccValues            ?: any,
    disableSaves         : any,
    loadWatermarkPdf     : () => any,
}) => cst<{
/*  CS ASSIGNMENT NODE TYPES  *****************************************************************************************/
    apis                    : Types.Apis.Loaders.XpressoLoadApis,
    state                : Types.Common.React.UseState.UseStateNext<{
        downloadPercent  : number,
    }>,
    onDownloadProgress   : (progressPercent:number) => void,
}>(
    consumeContext("apis"),

    // set state vars
    cstAssign("state", (_, next) => UseState({
        defaultValue: {
            downloadPercent: 0,
        },
        next,
    })),

    // set download progress event handler
    cstAssign("onDownloadProgress", ({state}, next) => next((progressPercent) => {
        state.onChange({...state.value, downloadPercent: progressPercent});
    })),

    // render component
    ({apis, state, onDownloadProgress}) => (
        <div className="watermark-download-d2w">
            <Button
                buttonText="Download Proof"
                xdQaName="Download Proof"
                disabled={disableSaves.value}
                downloadProgressPercent={state.value.downloadPercent}
                onClick={async () => {
                    disableSaves.onChange(true);
                    const pdf = await loadWatermarkPdf();
                    if (pdf) {
                        await downloadProofs(pdf, itemId, null, onDownloadProgress);
                    }
                    //log testing downloads from user created templates
                    if( ccValues?.userCreatedStateId ){
                        let logData = {
                            ccHost: ccValues.ccHost,
                            ccVersion: ccValues.ccVersion,
                            pdf: pdf,
                            sourceTemplateIds: ccValues.templateIds,
                            template: ccValues.template?.idState,
                            userCreatedStateId: ccValues?.userCreatedStateId
                        };
                        await apis.next.userCreated.updateLog({updateFields: {"type":"downloadProof","values": JSON.stringify(logData)}})
                    }
                    // remove download percent after another second to ensure that 100% status is displayed to the user
                    await setTimeout(() => state.onChange({...state.value, downloadPercent: 0}), 1000);
                    disableSaves.onChange(false);
                }}
            />
        </div>
    )
);


